import { useMemo } from "react"
import { Select, type SelectProps } from "~/components"
import { useTranslate } from "~/ur-react-hooks"

export interface GradeSelectProps
  extends Omit<SelectProps<number | null, any>, "options"> {}

const GradeSelect: React.FC<GradeSelectProps> = ({ ...props }) => {
  const translations = useTranslate({
    firstGrade: "school-grades.first",
    secondGrade: "school-grades.second",
    thirdGrade: "school-grades.third",
    fourthGrade: "school-grades.fourth",
    fifthGrade: "school-grades.fifth",
    sixthGrade: "school-grades.sixth",
    seventhGrade: "school-grades.seventh",
  })

  const options = useMemo(() => {
    return [
      { value: 1, label: translations.firstGrade },
      { value: 2, label: translations.secondGrade },
      { value: 3, label: translations.thirdGrade },
      { value: 4, label: translations.fourthGrade },
      { value: 5, label: translations.fifthGrade },
      { value: 6, label: translations.sixthGrade },
      { value: 7, label: translations.seventhGrade },
    ]
  }, [translations])

  return <Select {...props} options={options} />
}

export default GradeSelect
